import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import '@fortawesome/fontawesome-free/css/all.css'; // Ensure you are using css-loader

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: 'fa',
  },
  theme: {
    options: { customProperties: true },
    themes: {
      dark: {
        primary: '#002458',
        secondary: '#08a0a8',
        accent: '#08a0a8',
        error: '#b71c1c',
        info: '#2196F3',
        success: '#08a0a8',
        warning: '#FFC107',
      },
      light: {
        primary: '#002458',
        secondary: '#08a0a8',
        accent: '#08a0a8',
        error: '#b71c1c',
        info: '#2196F3',
        success: '#08a0a8',
        warning: '#FFC107',
      },
    },
  },
});
